import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import TreeCard from "../../../../../../atoms/ActiveLearning/TreeCard";
import Card from "../../../../../../atoms/ActiveLearning/Card";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconAdd } from "../../../../../../assets/images/ActiveLearning/icon_add.svg";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import hintImage06 from "../../../../../../assets/images/ActiveLearning/hint/img_06.webp";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const question1 = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 1);
    if (q) return q;
  }, [props.issue]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          「問い」の内容を実現するまでに、どんな問題が生まれるかを想像しよう。
          <br />
          その問題を取り除くことが「問い」に答えを出すことにつながる。
          <br />
          まずはヒントを参考にして、生まれるかもしれない問題を3つ以上入力してみよう。
        </p>
      </div>
      {question1 && (
        <div className={clsx(styles.question, styles.primary)}>
          <div className={styles.tree}>
            <TreeCard title={"問い"} text={"回答データがありません。"} />
            <ul className={styles.branchList}>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>問題</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>問題</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>問題</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
            </ul>
            <div className={styles.buttonWrapper}>
              <Button width={"150px"} height={"37px"} fontSize={"14px"}>
                <IconAdd />
                項目を追加する
              </Button>
            </div>
          </div>
          <img src={hintImage06} alt="問題を予測するためのヒント" />
          <Card label={"TRY"} icon={<IconLive />} title={"グループワーク"}>
            ①同じテーマ同士でグループをつくろう。
            <br />
            ②「問い」/ターゲット/ターゲットの抱える問題を発表し合おう。
            <br />
            ③ターゲットが強く思っている［もっと〇〇/〇〇したい］は何かを話し合おう。
          </Card>
        </div>
      )}
    </div>
  );
};
export default Issue2Material;
